export const testimonialsContent = {
  sectionTag: 'Clientes y Alianzas',
  headline: 'Navieras internacionales que confían en nuestra operación',
  subheadline:
    'La confianza de nuestros clientes no se solicita: se construye con cada entrega puntual. Esto es lo que dicen los operadores de flota que trabajan con nosotros.',
  testimonials: [
    {
      id: 1,
      quote:
        'En Avimar encontramos lo que no da la competencia: respuesta en menos de 2 horas y entrega exacta a lo solicitado. Llevamos 8 años operando con ellos en Coatzacoalcos y Veracruz.',
      author: 'Capt. James Morrison',
      role: 'Gerente de Operaciones',
      company: 'Pacific Maritime Services Ltd.',
      rating: 5,
    },
    {
      id: 2,
      quote:
        'Su capacidad de lanchaje en condiciones adversas nos salvó un despacho crítico. No es un proveedor: es un aliado operativo en cada puerto mexicano donde atracamos.',
      author: 'Elena Vásquez',
      role: 'Directora de Compras',
      company: 'TransOceanic Logistics Group',
      rating: 5,
    },
    {
      id: 3,
      quote:
        'El control de calidad de sus provisiones es riguroso. Nunca hemos tenido una devolución por producto en mal estado. Su cadena de frío es impecable.',
      author: 'Michael Chen',
      role: 'Superintendente de Flota',
      company: 'Global Seaways Corporation',
      rating: 5,
    },
    {
      id: 4,
      quote:
        'Desde que empezamos a usar su servicio de agencia consignataria, redujimos los tiempos de trámite portuario en un 40%. Su personal conoce cada reglamento local.',
      author: 'Ana Lucía Herrera',
      role: 'Agente Consignataria',
      company: 'Marina del Norte S.A.',
      rating: 5,
    },
    {
      id: 5,
      quote:
        'La recolección de residuos con documentación MARPOL completa nos da tranquilidad ante autoridades. Su cumplimiento normativo es ejemplar en el sector.',
      author: 'Robert K. Andersen',
      role: 'Oficial de Cumplimiento Ambiental',
      company: 'Nordic Shipping Alliance',
      rating: 5,
    },
    {
      id: 6,
      quote:
        'Su stock de cartas náuticas y publicaciones es el más completo que hemos encontrado en México. Siempre tienen la edición más reciente disponible.',
      author: 'Francisco Delgado',
      role: 'Oficial de Navegación',
      company: 'Ibero-American Shipping Co.',
      rating: 4,
    },
  ],
};